import { BaseService } from "@services/BaseService";

export interface SaveConversationPayload {
  conversation_id: number | null;
  messages: any;
}

export type ExternalApiAction = "enable" | "disable";

interface ExternalApiTogglePayload {
  api_keys: string[];
  action: ExternalApiAction;
}

class ConversationService extends BaseService {
  getUserConversations() {
    return this.get("/chat/conversations/");
  }

  getConversationById(conversation_id: number) {
    return this.get(`/chat/conversations/${conversation_id}`);
  }

  deleteConversation(conversation_id: number) {
    return this.delete(`/chat/conversations/${conversation_id}`);
  }

  toggleExternalApis(
    conversation_id: number,
    payload: ExternalApiTogglePayload
  ) {
    return this.post(
      `/chat/conversations/${conversation_id}/external-apis/toggle`,
      payload
    );
  }

  listEnabledExternalApis(conversation_id: number) {
    return this.get(`/chat/conversations/${conversation_id}/external-apis`);
  }
}

export const conversationService = new ConversationService();
